import * as tslib_1 from "tslib";
import { Injector } from '@angular/core';
import { of, BehaviorSubject, ReplaySubject } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { ThemeService } from '@awp/theme';
import { ContentService, ContentType, ContentParser } from '@awp/content';
import { wrapIntoObservable, isNullOrEmpty, trimSlash } from '@awp/core/utils';
import { AppConfig } from '@awp/core/config';
import { ClientService } from './client.service';
import * as i0 from "@angular/core";
import * as i1 from "./client.service";
var ThemeHalService = /** @class */ (function (_super) {
    tslib_1.__extends(ThemeHalService, _super);
    function ThemeHalService(clientService, injector) {
        var _this = _super.call(this) || this;
        _this.clientService = clientService;
        _this.injector = injector;
        _this._loaded = new BehaviorSubject(false);
        _this._changes = new ReplaySubject(1);
        _this.loaded = _this._loaded.asObservable();
        _this.changes = _this._changes.asObservable();
        return _this;
    }
    ThemeHalService.prototype.verifyTheme = function (themeId) {
        if (themeId === this.themeId) {
            return of(true);
        }
        var result = this.clientService.getClient(themeId);
        return wrapIntoObservable(result).pipe(map(function (p) { return p != null; }));
    };
    ThemeHalService.prototype.setTheme = function (themeId) {
        var savedThemeId = sessionStorage.getItem('themeId');
        if (themeId !== this.themeId) {
            this.themeId = themeId;
            this.clientService.setClient(this.themeId);
            var contentService = this.injector.get(ContentService);
            if (contentService != null) {
                contentService.setClient(this.themeId);
            }
            else {
                console.warn('Content Service is not defined');
            }
            this._themeId.next(themeId);
            if (isNullOrEmpty(savedThemeId) || savedThemeId !== themeId) {
                sessionStorage.setItem('themeId', this.themeId);
                this._changes.next(themeId);
            }
        }
    };
    ThemeHalService.prototype.getTheme = function () {
        var _this = this;
        if (this.currentTheme != null) {
            return of(this.currentTheme);
        }
        var contentService = this.injector.get(ContentService);
        var contentParser = this.injector.get(ContentParser);
        var appConfig = this.injector.get(AppConfig);
        return contentService.getContent('root')
            .pipe(map(function (p) {
            var cssUrl;
            if (p != null && p.theme != null && p.theme.type === ContentType.Css) {
                cssUrl = p.theme.href;
            }
            return {
                themeId: _this.themeId,
                url: {
                    themeUrl: trimSlash([trimSlash(appConfig.BASE_HREF), _this.themeId].join('/')),
                    cssUrl: cssUrl
                },
                pageTitle: contentParser.interpolate(p.pageTitle, p._embedded.properties),
                favIcon: p.favIcon,
                properties: p._embedded.properties
            };
        }), shareReplay(1));
    };
    ThemeHalService.prototype.reset = function () {
        this._loaded.next(false);
    };
    ThemeHalService.prototype.complete = function () {
        this._loaded.next(true);
    };
    ThemeHalService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ThemeHalService_Factory() { return new ThemeHalService(i0.ɵɵinject(i1.ClientService), i0.ɵɵinject(i0.INJECTOR)); }, token: ThemeHalService, providedIn: "root" });
    return ThemeHalService;
}(ThemeService));
export { ThemeHalService };
